import { render, staticRenderFns } from "./ProviderMainTabs.vue?vue&type=template&id=1dd4cd84&lang=pug&"
import script from "./ProviderMainTabs.vue?vue&type=script&lang=js&"
export * from "./ProviderMainTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProviderMainTabs.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {
  VDivider,
  VTab,
  VTabItem,
  VTabs,
})
